import {Component, NgZone} from '@angular/core';
import {isInEditor} from '@myvf/aem';
import {LoaderService} from './loader.service';

@Component({
  selector: 'myvf-loader',
  template: '<myvf-ui-spinner [show]="visible" [text]="text"></myvf-ui-spinner>'
})
export class LoaderComponent {
  public visible: boolean;
  public text: string;

  constructor(
    private service: LoaderService,
    private ngzone: NgZone
  ) {
    if (isInEditor()) {
      this.visible = false;
    } else {
      service
        .spinner
        .subscribe(data =>
          ngzone.run(a => {
            this.visible = data.show;
            this.text = data?.text;
          })
        );
    }
  }
}
